import type { ReactNode } from 'react';
import React from 'react';
import { Typography } from 'antd';

interface HighlightTextProps {
  children: ReactNode;
  highlight: string;
  [x: string]: any;
}
export const HighlightText: React.FC<HighlightTextProps> = ({ children, highlight, ...props }) => {
  const text = React.Children.toArray(children).join('');

  if (!highlight.trim()) {
    return <Typography.Text {...props}>{text}</Typography.Text>;
  }

  const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));
  return (
    <Typography.Text {...props}>
      {parts.map((part, idx) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={`${part}-${idx}`} style={{ backgroundColor: 'yellow' }}>
            {part}
          </span>
        ) : (
          <React.Fragment key={`${part}-${idx}`}>{part}</React.Fragment>
        ),
      )}
    </Typography.Text>
  );
};
